import type { PostHog } from "posthog-js";
import * as posthogNs from "posthog-js";

// Safely resolve the default export in edge/browser environments
const posthog = ((posthogNs as Record<string, unknown>).posthog ||
	(posthogNs as Record<string, unknown>).default ||
	posthogNs) as unknown as PostHog;

export { posthog };
